// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"start-stroop_wrapper__37taQ","text":"start-stroop_text__bU7ZB"};